import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentResourceOperation } from "types/generated";

const IntentProjectOperationsTableRowActionsCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<IntentResourceOperation>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Operation actions">
        <CopyFieldDropdownMenuItem value={item.id} title="Copy Operation ID" />
        <CopyFieldDropdownMenuItem value={item.resourceID} title="Copy Resource ID" />
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default IntentProjectOperationsTableRowActionsCell;
